<template>
    <div class="page-content" id="patrol-form">
        <Titlebar :incrustation="'fa-history'" :backPath="$route.query.patrolid">
            <h1>{{ $t('patrol.titles.compare') }}</h1>
        </Titlebar>
        <div class="patrol-error mb-4" v-if="timelineError" v-html="timelineErrorMessage"></div>
        <UiCard>
            <div class="row selection-header">
                <div class="col-6">
                    <div class="selection-block show w-25"></div>
                    <div class="selection-block w-25" :class="{show:canTheoricStart}">
                        <label>{{ $t('patrol.compare.form.theoricStart') }}</label>
                        <ClockPicker :nullable="true" :inputclass="'form-input'" v-model="theoricStart"></ClockPicker>
                    </div>
                    <div class="selection-block show w-50">
                        <label>{{ $t('patrol.compare.form.patrol') }}</label>
                        <select class="form-input" v-model="selectedPatrolId" v-can="'beepiz-select-patrols'">
                            <option v-for="patrol in filteredPatrols" :key="patrol.id" :value="patrol.id">{{ patrol.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-6">
                    <div class="selection-block show w-50">
                        <label>{{ $t('patrol.compare.form.resource') }}</label>
                        <div class="resource-selector-container" v-on-clickaway="closeResourceSelector">
                            <div
                                class="form-input resource-selector-selection"
                                :class="showResourceSelector && 'focus'"
                                @click="toggleResourceSelector"
                            ><i class="fa fa-caret-down"></i>{{ selectedResourceLabel }}
                            </div>
                            <div class="resource-selector-wrapper" :class="{show:showResourceSelector}">
                                <ResourceSelector
                                        :preselected="resourcePreselected"
                                        :config="resourceSelectorConfig"
                                        @change="handleChangeResourcesSelection"
                                ></ResourceSelector>
                            </div>
                        </div>

                    </div>
                    <div class="selection-block show w-25">
                        <label>{{ $t('patrol.compare.form.date') }}</label>
                        <DatePicker :inputclass="'form-input'" :max="getNow" v-model="selectedDate"></DatePicker>
                    </div>
                    <div class="selection-block w-25" :class="{show:starts.length > 0}">
                        <label>{{ $t('patrol.compare.form.startedAt') }}</label>
                        <div class="patrol-selector" v-if="starts.length <= 6">
                            <ul>
                                <li v-for="start in starts" @click="setStartedAt(start)"
                                    :class="{active:convertToTime(start) == startedAt}">{{ convertToTime(start) }}
                                </li>
                            </ul>
                        </div>
                        <select class="form-input" v-else @change="handleStartChange">
                            <option>Choisir</option>
                            <optgroup :label="day" v-for="day in startDays">
                                <option v-for="start in startsForDay(day)" :value="start">{{ convertToTime(start) }}</option>
                            </optgroup>

                        </select>
                    </div>
                </div>
            </div>

            <Timeline :theoric="getTheoricCheckpoints"
                      :real="realPatrol"
                      :theoricStart="getTheoricStart"
                      :realStart="getRealStart"
                      :manageTime="getManageTime"
                      :apDefs="apDefs"
                      :class="{'timeline-blur':timelineError}"
                      :zoom="zoom">
            </Timeline>

        </UiCard>
        <Toolbar>

            <div class="row">
                <div class="col">
                    <Btn :class="['default pull-left',{disabled:!canConsult}]" v-can="'beepiz-download-common'" @click.native="dlReport">
                        <i class="fa fa-file-pdf-o"></i> {{ $t('patrol.btns.print') }}
                    </Btn>
                </div>
                <div class="col center">
                    <Zoom v-show="isZoomable" :min="10" :max="30" :step="5" v-model="zoom" :label="'Echelle'"></Zoom>
                </div>
                <div class="col">
                    <!--<Btn :class="['primary pull-right',{disabled:!canConsult}]" @click.native.stop="loadCompare"
                 v-can="'patrols.patrols.edit'">
                {{ $t('patrol.btns.consult') }}
            </Btn>-->
                </div>
            </div>
        </Toolbar>
    </div>
</template>

<script>
    import API from '@/services/API.js';
    import Utils from '@/services/utils.js';
    import Auth from '@/services/auth.js';
    import axios from 'axios';
    import moment from 'moment';

    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from "@/components/ui/Card";
    import ClockPicker from '@/components/ui/datetime/TimePicker';
    import DatePicker from '@/components/ui/datetime/DatePicker';
    import ResourceSelector from '@/components/reports/ResourceSelector';

    import Timeline from '@/components/patrols/compare/Timeline';
    import Zoom from '@/components/ui/ZoomManager';

    import {mixin as clickaway} from 'vue-clickaway';

    import _some from 'lodash/some';
    import _filter from 'lodash/filter'

    export default {
        components: {
            Titlebar,
            Toolbar,
            Btn,
            UiCard,
            ClockPicker,
            DatePicker,
            ResourceSelector,
            Timeline,
            Zoom
        },
        data() {
          return {
            patrols: [],
            selectedPatrolId: null,
            selectedPatrol: null,
            selectedResourceType: null,
            selectedResource: null,
            selectedDate: moment().startOf('day'),

            theoricStart: null,
            startedAt: null,
            startedAtComplete: null,
            realPatrol: [],

            starts: [],

            apDefs: {},

            showResourceSelector: false,
            firstTimeResourceSelector: true,

            timelineError: false,
            timelineErrorMessage: '',

            zoom: 10,
            lockCompare: false,

            resourcePreselected: null,
            autoLoad: false
          }
        },
        computed: {
            resourceSelectorConfig: function () {
                return {
                    "type": [
                        "dati",
                        "identification"
                    ],
                    "q": [
                        1,
                        1
                    ]
                }
            },
            selectedResourceLabel: function () {
                if (this.selectedResource) {
                    return this.selectedResource.name;
                }
                return '';
            },
            canConsult: function () {
                if (this.selectedPatrol != null &&
                    this.selectedResourceType != null &&
                    this.selectedResource != null &&
                    this.selectedDate != null &&
                    this.startedAt != null) {
                    return true;
                }
                return false;
            },
            canTheoricStart: function () {
                if (this.selectedPatrol != null && this.selectedPatrol.manageTravelTime) {
                    return true;
                }
                return false;
            },
            getTheoricCheckpoints: function () {
                if (this.selectedPatrol != null) {
                    return this.selectedPatrol.checkpoints;
                }
                return [];
            },
            getTheoricStart: function () {
                if (this.selectedPatrol != null) {
                    return this.theoricStart;
                }
                return null;
            },
            getRealStart: function () {
                if (this.startedAt != null) {
                    return this.startedAt;
                }
            },
            getManageTime: function () {
                if (this.selectedPatrol != null) {
                    return this.selectedPatrol.manageTravelTime == 1 ? true : false;
                }
                return false;
            },
            getNow: function () {
                return moment();
            },

            constructReportFileName: function () {
                var name = Utils.t('patrol.compare.reportName') + " "+Utils.t('global.fromToDate1')+" " + moment(this.startedAtComplete).format(Utils.t('datetime.reportDateTime')) + "-" + this.selectedResourceLabel;
                return Utils.sanitize(name, true);
            },
            isZoomable: function(){
                if(this.selectedPatrol != null){
                    if(this.selectedPatrol.manageTravelTime == 1){
                        return true;
                    }
                }
                return false;
            },
            startDays(){
                let days = []

                let oldDay = null
                this.starts.forEach(item => {
                    let tempDay = moment(item)
                    if(tempDay.format('YYYY-MM-DD') != oldDay){
                        oldDay = tempDay.format('YYYY-MM-DD')
                        days.push(tempDay.format(Utils.t('datetime.date')))
                    }
                })

                return days
            },

            filteredPatrols(){
                if(this.patrols.length > 0){
                    return this.patrols.filter(item => {
                        return !Array.isArray(item)
                    })
                }
                return []
            }
        },
        methods: {
            loadPatrols: function () {
                var config = {
                    perpage: 99999
                };
                let time = '23:59:59'
                if(this.autoLoad){
                    time = this.$route.query.time
                }
                axios.get(API.endpoints.patrols.index + API.constructQueryParams(config) + '&date=' + this.selectedDate.format('YYYY-MM-DD')+' '+time)
                    .then(response => {
                        this.patrols = response.data.data;
                        if(this.selectedPatrolId){
                            this.loadPatrol(this.selectedPatrolId)
                        }
                        window.Vfc.$refs.loading.hide();
                    })
                    .catch(e => {
                        window.Vfc.$refs.loading.hide();
                    })
            },
            loadPatrol: function (patrolId) {
              console.log('LOAD PATROL')
                let time = '23:59:59'
                if(this.autoLoad){
                    time = this.$route.query.time
                }
                axios.get(API.route(API.endpoints.patrols.show, {patrolId: patrolId}) + '?date=' + this.selectedDate.format('YYYY-MM-DD')+' '+time)
                    .then(response => {
                        this.selectedPatrol = response.data;
                        this.selectedPatrolId = this.selectedPatrol.id
                        if (this.selectedPatrol.theoricStartAt) {
                            this.theoricStart = this.selectedPatrol.theoricStartAt;
                        }
                        else {
                            this.theoricStart = null;
                        }

                        for (var i = 0; i < this.selectedPatrol.checkpoints.length; i++) {
                            this.$set(this.apDefs, this.selectedPatrol.checkpoints[i].id, this.selectedPatrol.checkpoints[i]);
                        }

                    })
                    .catch(error => {
                        if (error.response != null) {
                            if(error.response.status == 422){
                                this.selectedPatrolId = null;
                                this.selectedPatrol = null;
                                this.startedAt = null;
                                this.startedAtComplete = null;
                                this.realPatrol = [];
                                this.starts = [];
                                this.theoricStart = null;
                                this.timelineError = true;
                                this.timelineErrorMessage = Utils.t('patrol.errors.noPatrolForDate');
                            }
                        }
                        else {
                        }
                    })
            },
            loadStarts: function () {
                if (this.selectedPatrol != null && this.selectedResourceType != null && this.selectedResource != null && this.selectedDate != null) {
                    let time = '00:00:00'
                    if(this.autoLoad){
                        time = this.$route.query.time
                    }
                    var params = {
                        patrolId: this.selectedPatrol.id,
                        resourceType: this.selectedResourceType,
                        resourceId: this.selectedResource.id,
                        date: moment(this.selectedDate, Utils.t('datetime.date')).format('YYYY-MM-DD')+' '+time
                    };

                    this.realPatrol = [];

                    axios.get(API.route(API.endpoints.patrols.start, params))
                        .then(response => {
                            this.starts = response.data;


                            if(this.starts.length == 0){
                                this.timelineError = true;
                                this.timelineErrorMessage = Utils.t('patrol.errors.noPatrolToday');
                            }
                            else{
                                this.timelineError = false;
                                if(this.autoLoad){
                                    this.autoLoad = false
                                    this.loadCompare()
                                }
                            }
                        })
                        .catch(error => {
                            if (error.response != null) {
                            }
                            else {
                            }
                        })
                }

            },
            loadCompare: function () {

                console.log('LOAD COMPARE', this.selectedPatrol, this.selectedResourceType, this.selectedResource, this.startedAtComplete, this.selectedDate, this.starts, this.starts.length)

                if (this.selectedPatrol != null
                    && this.selectedResourceType != null
                    && this.selectedResource != null
                    && this.startedAtComplete != null
                    && this.selectedDate != null
                    && this.starts != null
                    && this.starts.length > 0
                    && !this.lockCompare) {

                    this.lockCompare = true;
                    var params = {
                        patrolId: this.selectedPatrol.id,
                        resourceType: this.selectedResourceType,
                        resourceId: this.selectedResource.id,
                        date: this.startedAtComplete,
                        theoricDate: moment(moment(this.selectedDate).format('YYYY-MM-DD') + ' ' + this.theoricStart, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss')
                    };
                    axios.get(API.route(API.endpoints.patrols.compare, params))
                        .then(response => {
                            for (var i = 0; i < this.selectedPatrol.checkpoints.length; i++) {
                                var cp = this.selectedPatrol.checkpoints[i];
                                cp.present = response.data.theoric[i].present;
                                cp.order = response.data.theoric[i].order;
                                cp.inTime = response.data.theoric[i].inTime;
                                this.$set(this.selectedPatrol.checkpoints, i, cp);
                            }

                            this.realPatrol = response.data.real;

                            for (var i = 0; i < this.realPatrol.length; i++) {
                                if (this.selectedPatrol.checkpoints[i].id != this.realPatrol[i].id) {

                                    if (_some(this.realPatrol, {'id': this.selectedPatrol.checkpoints[i].id})) {

                                    }
                                    else {
                                        this.realPatrol.splice(i, 0, {id: null});
                                    }

                                }
                            }
                            window.Vfc.$refs.loading.hide();
                            this.lockCompare = false;
                        })
                        .catch(error => {
                            window.Vfc.$refs.loading.hide();
                            if (error.response != null) {
                            }
                            else {
                            }
                            this.lockCompare = false;
                        })
                }
            },
            setStartedAt: function (start) {
                console.log('setStartedAt', start, this.lockCompare)
                if(!this.lockCompare){
                    this.startedAt = this.convertToTime(start);
                    this.theoricStart = this.startedAt;
                    this.startedAtComplete = start;
                }

            },
            handleChangeResourcesSelection: function (data) {
                this.selectedResourceType = data.type;

                if (data.values !== null) {
                  if(Array.isArray(data.values) && data.values.length > 0){
                    this.selectedResource = data.values[0];
                    this.showResourceSelector = false;
                  }
                }
            },
            toggleResourceSelector: function () {
                this.showResourceSelector = !this.showResourceSelector;
                if (this.showResourceSelector) {
                    this.firstTimeResourceSelector = false;
                } else {
                    this.firstTimeResourceSelector = true;
                }
            },
            closeResourceSelector: function () {
                if (this.showResourceSelector && !this.firstTimeResourceSelector) {
                    this.showResourceSelector = false;
                    this.firstTimeResourceSelector = true;
                } else {
                    this.firstTimeResourceSelector = false;
                }
            },
            convertToTime: function (date) {
                return moment(date).format('HH:mm');
            },
            dlReport: function () {
                const outputFormat = 'pdf';
                var route = API.endpoints.reports['patrol'];
                var params = {
                    resourceType: this.selectedResourceType,
                    resourceId: this.selectedResource.id,
                    reportPeriod: moment(this.startedAtComplete,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') + ',' + moment(moment(this.selectedDate).format('YYYY-MM-DD') + ' ' + this.theoricStart, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
                    patrolId: this.selectedPatrol.id,
                    zoom: this.zoom
                }
                var apiRoute = API.route(route, params);

                    axios({
                      method: 'post',
                      url: '/beepiz/reports',
                      responseType: 'blob',
                      data: {
                        'reportSlug': 'patrol',
                        'resourceType': params.resourceType + '-' + params.resourceId,
                        'dates': params.reportPeriod,
                        'patrolid': this.selectedPatrol.id,
                        'zoom': this.zoom
                      },
                      headers: {
                        'Accept': Utils.getMimeFromOutput(outputFormat),
                        'Content-Type': 'application/json'
                      }
                    })
                    .then(response => {
                        // It is necessary to create a new blob object with mime-type explicitly set
                        // otherwise only Chrome works like it should
                        var newBlob = new Blob([response.data], {type: Utils.getMimeFromOutput(outputFormat)})

                        // IE doesn't allow using a blob object directly as link href
                        // instead it is necessary to use msSaveOrOpenBlob
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(newBlob, this.constructReportFileName + "." + outputFormat);
                            return;
                        }

                        // For other browsers:
                        // Create a link pointing to the ObjectURL containing the blob.
                        const data = window.URL.createObjectURL(newBlob);
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data;
                        link.download = this.constructReportFileName + "." + outputFormat;
                        link.click();
                        setTimeout(function () {
                            // For Firefox it is necessary to delay revoking the ObjectURL
                            window.URL.revokeObjectURL(data);
                        }, 100)

                    })

            },

            handleStartChange(event){
                console.log('setStartedAt', event.target.value)
                this.setStartedAt(event.target.value)
            },

            startsForDay(day){
                let mDay = moment(day,Utils.t('datetime.date')).format('YYYY-MM-DD')
                let starts = []

                starts = _filter(this.starts,item => {
                    return moment(item).format('YYYY-MM-DD') == mDay
                })

                return starts

            },

            compareFromParams(to){
                if(to.query.patrolid) {
                    window.Vfc.$refs.loading.show();
                    this.autoLoad = true
                    this.selectedDate = moment(to.query.date)
                    this.selectedPatrolId = to.query.patrolid
                    this.selectedResourceType = to.query.resourcetype
                    this.resourcePreselected = {
                        type: to.query.resourcetype,
                        values: [to.query.resourceid]
                    }
                    this.setStartedAt(to.query.date + ' ' + to.query.time)
                    this.loadStarts()
                }

            }
        },
        mixins: [clickaway],
        mounted: function () {
            if (!Utils.can('beepiz-browse-patrols')) {
                this.$router.push({ name: 'AccessDenied', params: { slug: 'patrols'} })
            } else {
                this.compareFromParams(this.$route)
                this.loadPatrols();
                if(window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_PATROL_TIMELINE_ZOOM') != null){
                    this.zoom = parseInt(window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_PATROL_TIMELINE_ZOOM'));
                }
            }
        },
        name: '',
        beforeRouteUpdate (to, from, next) {
            console.log(to)
            this.compareFromParams(to)
        },
        watch: {
            selectedPatrolId: function (newValue) {
                console.log('selectedPatrolId', newValue)
                if (newValue != '' && newValue != null) {
                    if(!this.autoLoad) {
                        this.loadPatrol(newValue);
                        this.startedAt = null;
                        this.startedAtComplete = null;
                        this.realPatrol = [];
                        this.starts = [];
                        this.theoricStart = null;
                        this.timelineError = false;
                    }
                }

            },

            selectedPatrol: function (newValue) {
                console.log('selectedPatrol', newValue)
                if (newValue != null) {
                    this.loadStarts();
                    //this.loadCompare();
                }

            },
            selectedResource: function (newValue) {
                console.log('selectedResource', newValue)
                if (newValue != null) {
                    if(!this.autoLoad) {
                        this.startedAt = null;
                        this.startedAtComplete = null;
                        this.realPatrol = [];
                        this.starts = [];
                        this.loadStarts();
                    }
                    //this.loadCompare();
                }

            },
            selectedDate: function (newValue) {
                console.log('selectedDate', newValue)
                if (newValue != null) {
                    if(!this.autoLoad) {
                        this.startedAt = null;
                        this.startedAtComplete = null;
                        this.realPatrol = [];
                        this.starts = [];
                        this.loadStarts();
                        this.loadPatrols();
                    }
                }

            },
            theoricStart: function (newValue) {
                console.log('theoricStart', newValue)
                // if (Math.abs(moment(newValue, 'HH:mm').diff(moment(this.startedAt, 'HH:mm'), 'minutes')) > 30) {
                //     this.timelineError = true;
                //     this.timelineErrorMessage = Utils.t('patrol.errors.tooLongDelay');
                // }
                // else {
                //     this.timelineError = false;
                //     console.log('COMPARE')
                //     this.loadCompare();
                // }
                console.log('COMPARE')
                this.loadCompare();

            },
            startedAt: function(newValue){
                console.log('startedAt', newValue)
                if (newValue != null) {
                    console.log('COMPARE')
                    this.loadCompare();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
